<template>
  <div>
    <!--<bread-crumb></bread-crumb>-->

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <!-- 작성자 이름 -->
          <admin-box-item title="1:1 문의 내용">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="작성자 이름">
                  <div>{{ value.name }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="작성자 이메일">
                  <div>{{ value.email }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="작성자 연락처">
                  <div>{{ value.phone }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="문의유형">
                  <div>{{ value.type }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="제목">
                  <div>{{ value.title }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="내용">
                  <div style="white-space: pre-line">{{ value.content }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="첨부파일">
                  <div v-for="file in value.files">
                    <div @click="openFile(file)" class="flex-align unselect"
                         style="cursor:pointer"><i class="material-icons" style="font-size:16px">attach_file</i><div>{{ fileName(file) }}</div></div>
                  </div>
                </admin-form-item>
              </div>

            </div>
          </admin-box-item>

          <!--&lt;!&ndash; 질문 내용 &ndash;&gt;
          <div class="lp-bg-sub-in-group">
            <div class="ask-content" style="width: 800px; height: 200px; padding: 12px 16px; overflow-y: auto;">{{ askContent.content }}</div>
            <div class="flex" v-if="askContent.imgs !== undefined && askContent.imgs.length>0">
              <div v-for="(img,idx) in askContent.imgs" :key="'qimg'+idx">
                <div @click="clickImg(img)">
                  <image-cropped :height="80" :img="img"
                                 :square="true" style="width:80px;margin-right:8px"></image-cropped>
                </div>
                <div class="lp-img-bg" v-if="vFull" @click="vFull=false">
                  <img class="lp-img-full" :src="image(fullImg)">
                </div>
              </div>
            </div>
          </div>-->
        </div>

        <div class="box">
          <admin-box-item title="1:1 문의 답변 등록">
            <div class="columns is-multiline">
              <!--<div class="column is-full">
                <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
                <admin-form-item label="작성자">
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="userlist"
                                     :selectVal="username"
                                     @onSelect="selectUser"
                                     added_field="type"
                                     placeholder="검색 후 선택"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="작성 내용">
                  <div class="flex">
                    <div style="margin-right:12px;width:90%">
                      <textarea class="textarea" v-model="value.answer_content"></textarea>
                    </div>
                    <div>
                      <button class="button is-primary"
                              style="height: 100% !important"
                              @click="clickCommentsReg">등록</button>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="clickCommentsReg">저장하기</button>
    </div>

  </div>
</template>

<script>
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    layout: 'Main',
    components: {
      LpAdmDropInput
    },
    created() {
      this.getUserList();
      this.getData();
    },
    computed: {
    },
    methods: {
      fileName(file){
        return decodeURI(file.split('/').slice(-1)[0]);
      },
      openFile(path){
        let link = document.createElement('a');
        let filename = path;
        link.download = filename;
        window.open(filename);
        link.click();
      },
      // 유저 선택
      selectUser(res) {
        this.value.user_id = res.value;
        this.value.user_type = res.type;
      },
      // 답변 등록
      clickCommentsReg() {
        let param = {
          user_id: this.value.user_id,
          user_type: this.value.user_type,
          answer_content: this.value.answer_content
        }
        this.$axios.patch(this.getUrl('inquiry/personal/'+this.$route.query.id), param
        ).then(res=>{
          if(res.status===200){
            this.toast('완료되었습니다.');
            this.$router.back();
          }
        })

      },
      getData(){
        if(this.$route.query.id){
          this.$axios.get(this.getUrl('inquiry/personal/')+this.$route.query.id)
            .then(res=>{
              this.value = res.data;
              if(res.data.user_type==='admin'){
                this.value.user_id = res.data.admin;
              }
              else if(res.data.user_type==='partner'){
                this.value.user_id = res.data.partner;
              }

              this.getUsername();
            })
        }
      },
      getUserList(){
        this.$axios.get('public/user/whole').then(res=>{
          this.userlist = res.data;

        })
      },
      getUsername(){
        if(this.userlist.length>0){
          for(let i=0; i<this.userlist.length; i++){
            if(this.userlist[i].value===this.value.user_id &&
              this.value.user_type===this.userlist[i].type){
              this.username = this.userlist[i].label;
              break;
            }
          }
        }

        if (this.username === '' && this.$store.getters.mode === 'admin') {
          let user = find(this.userlist, 'type', 'admin');
          if(user!==undefined) {
            this.username = user.label;
            this.value.user_type = user.type;
            this.value.user_id = user.value;
          }
        }

      }

    },
    data () {
      return {
        id: 0,
        // 문의 내용
        value: {
          name: '',
          email: '',
          phone: '',
          type: '',
          title: '',
          content: '',
          user_type: '',
          user_id: '',
          answer_content: ''
        },
        userlist: [],
        username: '',
        vFull: false,
        fullImg: ''
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .comment-sub-title
    background #ddd
    color #333
    padding 8px 16px
    font-size 0.95rem
    border-radius 3px
    display flex
    justify-content space-between

  .ask-content
    width 260px
    padding 6px 10px
    font-size .85rem
    color #555
    border-radius 3px
    display inline-block
    border 1px solid #ddd

  .lp-img-bg
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0,0,0,0.5)
    z-index 100

  .lp-img-full
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
    max-height 80vh

</style>
